define('../common/js/utm',['require','exports','module','utils'],function(require, exports, module) {
    var utils = require('utils');
    var UTM_TYPES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var utm = UTM_TYPES.reduce(function (prev, name) {
        var val = utils.getParameterByName(name);
        if (val) {
            prev = prev + (prev ? '&' : '') + name + '=' + val;
        }
        return prev;
    }, '');

    if (utm) {
        $('a.js-signin, a.js-signup, a.js-tariffs-signup').prop('href', function (i, oldVal) {
            return oldVal + (oldVal.indexOf('?') < 0 ? '?' : '&') + utm;
        });
    }

    module.exports = {
        UTM_TYPES: UTM_TYPES
    };
});

